export function getFacilityScope(detailedFacility) {
    return detailedFacility?.facilityInfoResponse?.scope;
}
